module.exports = __webpack_public_path__ + "static/mobile-dashboard-070c82f4b7f293403232410449b1f6cd.jpg";